module.exports = __webpack_public_path__ + "05_glasses_black.e4f026cc.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/papa/layer4/05_glasses_black.png
// module id = PoMO
// module chunks = 0